import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AppWrapper from "./app/AppWrapper";
// import ExternalLinkDonation from "./pages/ExternalLinkDonation";
import ForgetPassword from "./pages/Views/forgetPassword/forgetPassword";

const Application = (props) => {
  return (
    <Router>
      <Switch>
        {/* <Route
          path="/external-link-donation"
          render={() => <ExternalLinkDonation />}
        /> */}
        <Route
          exact
          path="/forgot-password"
          render={() => <ForgetPassword />}
        />
        <Route path="/">
          <AppWrapper />
        </Route>
      </Switch>
    </Router>
  );
};

export default Application;
